require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js
// module id = 1553
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21